import { useState } from "react"
import { TablesInformations } from "../models/Components/TablesInformations";

type TablesInformationsPopupProps = {

    tables: TablesInformations[]
}

const DecisionTablePopup = ({ tables }: TablesInformationsPopupProps) => {

    const [show, setShow] = useState<boolean>(false);

    return (
        <>
            <span onClick={e => setShow(true)} style={{ cursor: 'pointer' }}><i className="bi bi-question-circle-fill ms-2"></i></span>

            <div className={"modal fade" + (show ? " show" : "")} role="dialog" tabIndex={-1}>
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5>Information about tables</h5>
                            <button type="button" className="btn-close" onClick={e => setShow(false)}></button>
                        </div>

                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12">
                                    {
                                        tables.map((x, index) => {
                                            return (
                                                <div className="form-group">
                                                    <label className="fw-bold">{x.name}</label>
                                                    <p>{x.description}</p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>

    )
}

export default DecisionTablePopup;